export const getHostApis = () => {
  // The host browser injects these on window, which a server render has none of.
  if (import.meta.server) {
    return { chrome: undefined, shift: undefined, onelaunch: undefined }
  }
  return {
    chrome: window?.chrome,
    shift: window?.chrome?.shift,
    onelaunch: window?.chrome?.onelaunch,
  }
}
